// KWANKGM02030_借入相談受付完了
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Finish from './BorrowingConsultationFinishDetail';
import { StepNavigation as StepType } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  is_staff: boolean;
  opened_mypage: boolean;
  is_loading: boolean;
  ja_name: string;
  guarantors_num: number;
}

const BorrowingConsultationFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  is_staff,
  opened_mypage,
  is_loading,
  ja_name,
  guarantors_num,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={false}
      />
      <Finish
        ja_name={ja_name}
        reception_cd={reception_cd}
        is_staff={is_staff}
        opened_mypage={opened_mypage}
        guarantors_num={guarantors_num}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationFinish;
